// Timeline status configuration for discipline events
import {
  CalendarDaysIcon,
  CheckCircleIcon,
  ClockIcon,
  DocumentDuplicateIcon,
  DocumentTextIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
  MinusCircleIcon,
  BellIcon,
  QuestionMarkCircleIcon,
  ScaleIcon,
  XCircleIcon
} from '@heroicons/react/24/outline';

export const TIMELINE_STATUS_CONFIG = {
  // Past events (mentions/demerits)
  active: {
    color: 'badge-warning',
    icon: ExclamationTriangleIcon,
    label: 'Active'
  },
  resolved: {
    color: 'badge-success',
    icon: CheckCircleIcon,
    label: 'Resolved'
  },
  // Future events (detentions/suspensions)
  scheduled: {
    color: 'badge-info',
    icon: CalendarDaysIcon,
    label: 'Scheduled'
  },
  served: {
    color: 'badge-success',
    icon: CheckCircleIcon,
    label: 'Served'
  },
  excused: {
    color: 'badge-neutral',
    icon: XCircleIcon,
    label: 'Excused'
  }
};

// Map emoji icons to Heroicon components for consistent UI
export const ICON_MAP = {
  mention: ExclamationTriangleIcon,
  demerit: MinusCircleIcon,
  detention: ClockIcon,
  'friday-detention': ClockIcon,
  'saturday-detention': ClockIcon,
  'homework-detention': ClockIcon,
  suspension: XCircleIcon,
  'suspension-pending-review': XCircleIcon,
  'privilege-loss': MinusCircleIcon,
  referral: DocumentTextIcon,
  warning: ExclamationTriangleIcon,
  notification: BellIcon,
  'contract-consequence': DocumentTextIcon,
  'duplicate-resolution': DocumentDuplicateIcon,
  consequence: ExclamationCircleIcon,
  'mention-rule-consequence': ScaleIcon,
  unknown: QuestionMarkCircleIcon
};

// Statuses that represent completed/terminal states — items with these statuses
// are hidden from the default queue view (unless actioned during the current session)
export const TERMINAL_STATUSES = ['served', 'excused', 'late', 'archived', 'cancelled', 'escalated', 'rescheduled'];

// A no-show and a learner absent from school require follow-up. Late is a
// completed attendance outcome, not an automatic follow-up case.
export const FOLLOW_UP_STATUSES = ['missed', 'absent'];

// Get status filters based on event type
export const getStatusFiltersForType = (eventType) => {
  if (eventType === 'mention' || eventType === 'demerit') {
    return [
      { value: 'active', label: 'Active' },
      { value: 'resolved', label: 'Resolved' }
    ];
  } else if (eventType === 'detention' || eventType === 'suspension') {
    return [
      { value: 'scheduled', label: 'Scheduled' },
      { value: 'served', label: 'Served' },
      { value: 'excused', label: 'Excused' }
    ];
  }
  return [];
};
